import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../../../constants/pages-and-paths';
import {AuthGuardService} from '../../../../../guards/auth-guard.service';
import {EditBlogComponent} from './edit-blog.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.adminEditBlog.pageInRouting,
    data: {data: PAGES_AND_PATHS.adminEditBlog},
    component: EditBlogComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./edit-blog.module').then(m => m.EditBlogModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EditBlogRoutingModule { }
